import { useState, useMemo } from "react"
import { Button } from "../Button"
import "./styles.scss"

export const TableInput = ({ answer, onChangeQuestionsInfo, register, values, getInputType }) => {
  const [showModal, setShowModal] = useState(false)
  const [currentRow, setCurrentRow] = useState({})

  const fields = useMemo(() => {
    try {
      return JSON.parse(answer?.info || '{}')
    } catch (e) {
      console.error('Error parsing table info:', e)
      return {}
    }
  }, [answer?.info])

  const [tableData, setTableData] = useState(() => {
    try {
      return values?.[answer?.id]?.value ? JSON.parse(values[answer?.id].value) : []
    } catch (e) {
      console.error('Error parsing table data:', e)
      return []
    }
  })

  const handleAddRow = () => {
    const emptyRow = Object.keys(fields).reduce((acc, key) => {
      acc[key] = ''
      return acc
    }, {})
    setCurrentRow(emptyRow)
    setShowModal(true)
  }

  const handleSaveRow = () => {
    const newData = [...tableData, currentRow]
    setTableData(newData)
    onChangeQuestionsInfo(answer.type, { value: JSON.stringify(newData), valid: true }, answer?.id, answer)
    setShowModal(false)
    setCurrentRow({})
  }

  const handleDeleteRow = (index) => {
    const newData = tableData.filter((_, i) => i !== index)
    setTableData(newData)
    onChangeQuestionsInfo(answer.type, { value: JSON.stringify(newData), valid: true }, answer?.id, answer)
  }

  const handleFieldChange = (field, value) => {
    setCurrentRow(prev => ({
      ...prev,
      [field]: value
    }))
    console.log("TRET", field, value)
    onChangeQuestionsInfo(answer.type, { value, valid: true, toRemove: true }, `${answer?.id}-${field}`, answer)
  }

  return (
    <div className="table-input">
      <div className="table-input__header">
        <Button label="Adicionar Linha" onClick={handleAddRow} />
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table className="table-input__table">
          <thead>
            <tr>
              {Object.entries(fields).map(([key, field]) => (
                <th key={key} style={{
                  padding: '8px',
                  minWidth: '120px',
                  whiteSpace: 'nowrap',
                  borderBottom: '1px solid #ccc',
                }}>{field.title}</th>
              ))}
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                {Object.keys(fields).map(key => (
                  <td key={key}>
                    {typeof row[key] === 'object' && row[key] !== null ? row[key]?.value : row[key] || ''}
                  </td>
                ))}
                <td>
                  <Button onClick={() => handleDeleteRow(index)} label="Excluir" variant="danger" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="table-input__modal-overlay">
          <div className="table-input__modal">
            <div className="table-input__modal-header">
              <h3>Adicionar Registro</h3>
              <button className="table-input__modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            <div className="table-input__modal-content">
              {Object.entries(fields).map(([key, field]) => {
                const mockAnswer = {
                  id: key,
                  type: field.type,
                  title: field.title,
                  options: field.options,
                  value: ""
                }

                const input = getInputType?.(
                  mockAnswer,
                  (type, value, id, answer) => handleFieldChange(key, value),
                  null, null, null, null, null,
                  () => ({
                    onChange: (e) => {
                      const value = { value: e.target?.value, valid: true }
                      onChangeQuestionsInfo(mockAnswer.type, value, mockAnswer.id, mockAnswer)
                      handleFieldChange(key, e.target?.value === "" ? "" : value)
                    }
                  }),
                  { [mockAnswer.id]: currentRow[key] }
                )

                return (
                  <div key={key} className="table-input__field">
                    <label>{field.title}</label>
                    {input || <input disabled placeholder="Erro ao renderizar input" />}
                  </div>
                )
              })}
            </div>
            <div className="table-input__modal-footer">
              <Button label="Cancelar" onClick={() => setShowModal(false)} variant="secondary" />
              <Button label="Salvar" onClick={handleSaveRow} variant="primary" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

